<template>
  <WorksDetailsMain
    class="form-wrap"
    v-if="!$store.state.env.isMobile"
  ></WorksDetailsMain>
  <WorksDetailsMainMobile v-else></WorksDetailsMainMobile>
</template>
<script>
import WorksDetailsMain from "@/components/works/WorksDetailsMain";
import WorksDetailsMainMobile from "@/components/works/WorksDetailsMainMobile.vue";
export default {
  name: "WorksDetails",
  components: {
    WorksDetailsMain,
    WorksDetailsMainMobile
  }
};
</script>
<style lang="scss" scoped>
</style>